(function($){

	$(document).ready(function(){

		$(document).on('click','.alert-module .icon-show',function(e){
			e.preventDefault();
			$(this).hide();
			$(this).siblings('.alert-module__text').addClass('is-shown');
			$(this).parents('.alert-module__wrapper').addClass('align-start');
		});

		$(window).on('load resize',function(){
			const alert_text = document.querySelector('.alert-module__text');

			if($(alert_text).length) {
				const icon_show = alert_text.nextElementSibling;

				if(isEllipsisActive(alert_text) && icon_show.classList.contains('icon-show')) {
					icon_show.style.display = 'block';
				} else {
					icon_show.style.display = 'none';
				}
			}
		});

		function isEllipsisActive(e) {
	  		return (e.offsetWidth < e.scrollWidth);
		}

	});
	
})(jQuery);